const requestAll = (actions, store) =>
  Promise.all(
    // eslint-disable-next-line
    actions.map(a => {a()( store.dispatch )}))
    .catch(e => {
    console.log('Не удалось загрузить все данные из-за ошибки');
    console.log(e);
  });

export default requestAll;



// WEBPACK FOOTER //
// ./src/actions/Common.js